// src/pages/admin/mixedCompanyAssignJobs/LiveSearchSelect.jsx — type-to-filter select used
// across MixedCompanyAssignJobs for customer/site pickers.
import { useEffect, useMemo, useState } from "react";
import { inputClass } from "./styles";

export default function LiveSearchSelect({
  value,
  onChange,
  options = [],
  placeholder = "Search...",
  emptyText = "No results found.",
  className = "",
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const selected = useMemo(
    () => options.find((opt) => String(opt.value) === String(value)) || null,
    [options, value],
  );

  const filteredOptions = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return options;
    return options.filter((opt) =>
      [opt.label, opt.searchText, opt.description]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .includes(q),
    );
  }, [options, query]);

  useEffect(() => {
    setQuery(selected?.label || "");
  }, [selected]);

  return (
    <div className={`relative ${className}`.trim()}>
      <input
        type="search"
        value={query}
        disabled={disabled}
        onFocus={(event) => {
          setOpen(true);
          event.target.select();
        }}
        onBlur={() => setTimeout(() => setOpen(false), 120)}
        onChange={(event) => {
          setQuery(event.target.value);
          setOpen(true);
        }}
        placeholder={placeholder}
        className={`${inputClass} ${disabled ? "cursor-not-allowed bg-gray-50 text-gray-400" : ""}`}
      />

      {open && !disabled ? (
        <div className="absolute left-0 right-0 top-full z-50 mt-2 max-h-64 overflow-auto rounded-xl border border-gray-200 bg-white p-1.5 shadow-lg">
          {filteredOptions.length ? (
            filteredOptions.map((opt) => {
              const isSelected = String(opt.value) === String(value);
              return (
                <button
                  key={opt.value}
                  type="button"
                  onMouseDown={(event) => event.preventDefault()}
                  onClick={() => {
                    onChange(opt.value);
                    setQuery(opt.label);
                    setOpen(false);
                  }}
                  className={`mb-1 flex w-full flex-col items-start rounded-lg px-3 py-2 text-left text-sm transition ${
                    isSelected
                      ? "bg-emerald-50 text-emerald-700"
                      : "text-gray-800 hover:bg-gray-50"
                  }`}
                >
                  <span className="font-medium">{opt.label}</span>
                  {opt.description ? (
                    <span className="mt-0.5 text-xs text-gray-500">
                      {opt.description}
                    </span>
                  ) : null}
                </button>
              );
            })
          ) : (
            <div className="px-3 py-2 text-sm text-gray-500">{emptyText}</div>
          )}
        </div>
      ) : null}
    </div>
  );
}
